module.exports = __webpack_public_path__ + "img/google18.2d7f64b4.jpg";